/**
 * @file index.tsx
 *
 * @fileoverview Renders message indicating that the user is masqueraded.
 */
import { useState } from 'react';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { MessageAlert } from '~/vcl/atoms/02-messages/01-alert';

export const MasqueradedMessage = () => {
  const { masqueraded }: UserContextInterface = useContext(UserContext);
  const [show, setShow] = useState<boolean>(masqueraded);

  return show ? (
    <MessageAlert
      alertStyle="warning"
      key="masqueraded_banner"
      onClose={() => setShow(false)}
    >
      <FormattedMessage
        id="masqueraded_message"
        defaultMessage="You are logged in as a masqueraded user."
      />
    </MessageAlert>
  ) : null;
};
